import {
  INITIALIZE,
  PERMIT_CREATE,
  PERMIT_READ,
  PERMIT_UPDATE,
  PERMIT_DELETE,
  DISPATCH_CREATE_INFORM,
  DISPATCH_CREATE_SUCCESS,
  DISPATCH_CREATE_FAIL,
  DISPATCH_READ_INFORM,
  DISPATCH_READ_SUCCESS,
  DISPATCH_READ_FAIL,
  DISPATCH_UPDATE_INFORM,
  DISPATCH_UPDATE_SUCCESS,
  DISPATCH_UPDATE_FAIL,
  DISPATCH_DELETE_INFORM,
  DISPATCH_DELETE_SUCCESS,
  DISPATCH_DELETE_FAIL,
} from './actions'

export function composePermit (operation) {
  return function (state, { payload }) {
    return {
      ...state,
      permit: {
        ...state.permit,
        [operation]: !!payload,
      },
    }
  }
}

export function composeDispatch (operation, dispatchType) {
  return function (state, { payload }) {
    const increase = !!payload
    const current = state[operation][dispatchType]
    const next = increase ? current + 1 : current - 1

    return {
      ...state,
      [operation]: {
        ...state[operation],
        [dispatchType]: next > 0 ? next : 0,
      },
    }
  }
}

const reducers = {
  [PERMIT_CREATE]: composePermit('create'),
  [PERMIT_READ]: composePermit('read'),
  [PERMIT_UPDATE]: composePermit('update'),
  [PERMIT_DELETE]: composePermit('delete'),
  [DISPATCH_CREATE_INFORM]: composeDispatch('create', 'inform'),
  [DISPATCH_CREATE_SUCCESS]: composeDispatch('create', 'success'),
  [DISPATCH_CREATE_FAIL]: composeDispatch('create', 'fail'),
  [DISPATCH_READ_INFORM]: composeDispatch('read', 'inform'),
  [DISPATCH_READ_SUCCESS]: composeDispatch('read', 'success'),
  [DISPATCH_READ_FAIL]: composeDispatch('read', 'fail'),
  [DISPATCH_UPDATE_INFORM]: composeDispatch('delete', 'inform'),
  [DISPATCH_UPDATE_SUCCESS]: composeDispatch('delete', 'success'),
  [DISPATCH_UPDATE_FAIL]: composeDispatch('delete', 'fail'),
  [DISPATCH_DELETE_INFORM]: composeDispatch('fail', 'inform'),
  [DISPATCH_DELETE_SUCCESS]: composeDispatch('fail', 'success'),
  [DISPATCH_DELETE_FAIL]: composeDispatch('fail', 'fail'),
  [INITIALIZE]: function (state, { payload }) {
    return {
      ...state,
      ...payload,
    }
  },
}

export default function (state, action) {
  try {
    const { type } = action
    const reducer = reducers[type]

    if (typeof reducer === 'function') {
      return reducer(state, action)
    }
  } catch (error) {
    console.error(error)
  }

  return state
}
